const getRandomUUID = () => {
    return crypto.randomUUID()
}

export default getRandomUUID
